var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFuel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.913 2.687L11.18.953c-.087 0-.26-.086-.347-.086h-.866c-.26 0-.434.173-.434.433s.174.433.434.433h.433l.867.867h-.434c-.26 0-.433.173-.433.433v1.734c0 .26.173.433.433.433h1.3v3.467c0 .52-.346.866-.866.866s-.867-.346-.867-.866V6.5c0-.26-.173-.433-.433-.433h-1.3V1.3c0-.693-.607-1.3-1.3-1.3h-5.2c-.694 0-1.3.607-1.3 1.3v10.833H0V13h9.533v-.867h-.866v-5.2h.866v1.734c0 .953.78 1.733 1.734 1.733.953 0 1.733-.78 1.733-1.733V3.033c0-.086-.087-.26-.087-.346zM1.733 3.9V1.3c0-.26.174-.433.434-.433h5.2c.26 0 .433.173.433.433v2.6c0 .26-.173.433-.433.433h-5.2c-.26 0-.434-.173-.434-.433zm9.534.433v-.866h.866v.866h-.866z",
    fill: "#A4A4A4"
  })));
}

export default SvgFuel;